(function () {
  "use strict";

  angular
    .module('trainerWebApp.directives')
    .directive('mfCopyPasteUrl', mfCopyPasteUrl);

  function mfCopyPasteUrl() {
    return function (scope, element, attrs) {

      function select() {
        element[0].select();
      }

      element.bind('focus', select);
      element.bind('click', select);

      scope.$watch('modal.content', function (newValue) {
        if (!newValue) return;

        setTimeout(select, 1000);
      });
    }
  }

})();
